import TimeOnTaskReport from '../../../../../../components/TimeOnTaskReport';
import { useParams } from 'react-router';
import { useNavigate } from 'react-router-dom';

const TTReport = ()=>
{
  const { Id } = useParams();
  const navigate = useNavigate();
  
  return (
    <>
      <TimeOnTaskReport assignmentId={Id}
        includeRetakes={false}
        classId={-1}
        isFromTeacherReport={false}
        backButtonOnClick={()=>navigate(-1)}
        isLoginActivityReport={false} />
    </>
  );
};

export default TTReport;